import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router'
import { PERMISSION_ACTION_EDIT, PERMISSION_ENTITY_SUPPLIER, ROUTE_SUPPLIERS } from '@klear/constants'
import { SupplierWizard } from '@klear/supplier-ui/supplier-wizard'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { useTrader } from '@klear/ui/hooks/use-trader'
import { useReturnUrlExit } from '@klear/ui/wizard/return-url'
import { useSupplier } from '@klear/ui/hooks/use-suppliers'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'
import toInteger from 'lodash/toInteger'
import BankAccounts from '@/app/supplier/bank-accounts'

export interface SupplierWizardPageProps {
  mode: 'create' | 'view' | 'edit'
}

export default function SupplierWizardPage({ mode }: SupplierWizardPageProps) {
  const { traderId, supplierId } = useParams()
  const navigate = useNavigate()
  const { urlPrefixApp } = useTrader(traderId)
  const { user } = useAuth()

  const tid = toInteger(traderId)
  const id = supplierId ? toInteger(supplierId) : 0
  const base = `${urlPrefixApp}/${ROUTE_SUPPLIERS}`
  const { supplier } = useSupplier(id, tid)
  useDocumentTitle(supplier?.name, mode === 'create' ? 'New Supplier' : mode === 'edit' ? 'Edit Supplier' : 'Supplier')
  const canEditSupplier = !!user?.hasPermission(PERMISSION_ENTITY_SUPPLIER, PERMISSION_ACTION_EDIT)

  const { exit, exitAfterSave } = useReturnUrlExit(base)
  const goToEdit = useCallback(() => navigate(`${base}/${id}/${PERMISSION_ACTION_EDIT}`), [navigate, base, id])

  return (
    <SupplierWizard
      mode={mode}
      supplierId={mode !== 'create' ? id : undefined}
      traderId={tid}
      showTraderSelect={false}
      showIdentifiers
      showParentOrganization={false}
      showCompanyLookup={mode === 'create' || mode === 'edit'}
      canEdit={mode === 'view' ? canEditSupplier : true}
      viewExtras={mode === 'view' && id ? <BankAccounts /> : undefined}
      onEdit={mode === 'view' ? goToEdit : undefined}
      onBack={exit}
      onDone={exitAfterSave}
    />
  )
}
